import cn from 'classnames';

import DefaultLink from 'components/common/DefaultLink';
import { PRIVACY_POLICY_PATH } from 'lib/constants/routingConstants';

const PrivacyPolicy = ({ classNames = '', text }) => (
  <DefaultLink
    isExternal
    to={PRIVACY_POLICY_PATH}
    target="_blank"
    className={cn(classNames, 'textSm inline p-0')}
  >
    {text}
  </DefaultLink>
);

PrivacyPolicy.propTypes = {
  classNames: PropTypes.string,
  text: PropTypes.string.isRequired,
  brandStylesOverrides: PropTypes.string,
};

export default PrivacyPolicy;
